import { AsyncPolling, AsyncPollingConfig } from '../../../utils/coreUtils';
import { ServiceDiscoveryResponse } from './InfaLogin.type';

class InfaTenantStatusPolling extends AsyncPolling<ServiceDiscoveryResponse> {
	constructor(
		private serviceDiscoveryCall: () => Promise<ServiceDiscoveryResponse>,
		config: AsyncPollingConfig<ServiceDiscoveryResponse>,
	) {
		super(config);
	}
	async poll() {
		return await this.serviceDiscoveryCall();
	}
}

export default InfaTenantStatusPolling;
